import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const accessTokenKey = 'TRADLE_TOKEN_DELIVERY'

const state = {
  isLoggedIn: !!localStorage.getItem(accessTokenKey),
  token: localStorage.getItem(accessTokenKey),
  isLoading: false,
  error: '',
  config: {
    jwtHeader: 'authorization',
    jwtPrefix: 'Bearer'
  }
}

export default {
  namespaced: true,
  state,
  actions: {
    ...actions,
    logout ({ commit }) {
      commit('UPDATE_TOKEN', '')
      commit('SET_LOGGED_IN', false)
    }
  },
  mutations,
  getters
}
